import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BookingForm from "@/components/BookingForm";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Book() {
  return (
    <div data-testid="book-page" className="min-h-screen bg-white">
      <Header />
      <main className="py-16 lg:py-24 bg-[#F8FAFC] border-b border-[#E2E8F0]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            data-testid="back-home-link"
            className="inline-flex items-center gap-2 text-sm text-[#475569] hover:text-[#0A192F]"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <div className="mt-6 text-[11px] font-bold uppercase tracking-[0.22em] text-[#0055FF]">
            Book Consultation
          </div>
          <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] tracking-tight">
            Let&apos;s find the right first step for your child.
          </h1>
          <p className="mt-4 text-[#475569] max-w-2xl">
            Fill in a few details and our team will reach out within 24 hours
            to confirm your consultation.
          </p>

          <div className="mt-10">
            <BookingForm />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
